import { Controller } from "@hotwired/stimulus";
import { Track } from "app/helpers/track";

// Page-level controller for step4: shows the "flight times changed"
// warning modal on load when the order was rescheduled, replacing the old
// fancybox-triggered version.
export default class extends Controller {
  static targets = ["rescheduledFlag", "rescheduledModal"];

  connect() {
    if (this.hasRescheduledFlagTarget && this.rescheduledFlagTarget.dataset.rescheduled === "true") {
      this.rescheduledModalTarget.classList.remove("hidden");
      this.rescheduledModalTarget.classList.add("flex");
      Track.log("Show rescheduled flight");
    }
  }

  closeRescheduled() {
    this.rescheduledModalTarget.classList.add("hidden");
    this.rescheduledModalTarget.classList.remove("flex");
  }

  // Wired on the modal's own backdrop -- event.currentTarget is that
  // backdrop, event.target is whatever was actually clicked, equal only
  // when the click didn't bubble up from the card content inside it.
  closeRescheduledOnBackdrop(event) {
    if (event.target === event.currentTarget) this.closeRescheduled();
  }
}
